import React from 'react'
import { linkResolver } from './linkResolver'

export const repositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_MAIN_REPOSITORY_NAME,
    linkResolver,
    componentResolver: {
      blog: React.lazy(() => import('../templates/blog')),
      blogpost: React.lazy(() => import('../templates/blogpost')),
      page: React.lazy(() => import('../templates/page')),
      team_member: React.lazy(() => import('../templates/teamMember'))
    }
  }
]
